package devxertech.com.pages.portfolio.tcld

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.ZoneArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.portfolio.zone.CommonAppView
import devxertech.com.pages.portfolio.zone.CommonWebView
import devxertech.com.pages.portfolio.zone.CommonZoneAbout
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/tcld")
@Composable
fun TcldPage() {
    PageMetadataForCurrentRoute()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            mainHeadingAsH1 = true,
            image = Res.Image.tcld_header,
            imageAlt = "TCLD IoT project",
            breakpoint = breakpoint,
            headingText = "TCLD IOT",
            descriptionText = "This is an iOT based project interacting with APIs , AWS amplify and ESPTouch  Smart Configs.",
            startProject = false, careerHeight = true, careerFontSize = true, heightModification = true, commonPortfolioChanges = true
        )
        ZoneArrow("TCLD IOT")
        CommonZoneAbout(image = Res.Image.tcld_icon, title = "TCLD IOT",
            description = "This is an iOT based project interacting with APIs , AWS amplify and ESPTouch  Smart Configs.")
        CommonAppView(image = Res.Image.tcld_png, breakpoint)
        CommonWebView(image = Res.Image.tcld_webview, breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}
